<div class="app-toasts">
  @for (toast of toasts$ | async; track toast) {
    <ngb-toast
      aria-atomic="true"
      [attr.aria-live]="toast.ariaLive"
      [autohide]="toast.autohide ?? true"
      [delay]="toast.delay ?? 500"
      [class]="toast.classname ?? ''"
      [header]="toast.header ?? ''"
      (click)="removeToast(toast.id)"
      (hidden)="removeToast(toast.id)"
      data-cy="toastMessage"
      data-testid="toastMessage"
    >
      @if (isTemplate(toast.textOrTemplate)) {
        <ng-template [ngTemplateOutlet]="toast.textOrTemplate" />
      } @else {
        {{ toast.textOrTemplate }}
      }
    </ngb-toast>
  }
</div>
